import DocumentToValidateDetailPage from '@/pages/requests/detailPages/supplierDetailPages/DocumentToValidateDetailPage.vue'
import InvoiceCreateForm from '@/pages/requests/creationPages/InvoiceCreateTemplate.vue'
import PaymentFromApplicationForm from '@/pages/LMSGiframe/PaymentFromApplicationForm.vue'
import ProjectCreateForm from '@/pages/requests/creationPages/ProjectCreateTemplate.vue'
import SupplierCreateForm from '@/pages/requests/creationPages/SupplierCreateTemplate.vue'
import SuppliersList from '@/pages/requests/SuppliersList.vue'
import SuppliersDetailPage from '@/pages/requests/detailPages/supplierDetailPages/SupplierDetailPage.vue'
import SuppliersDocForm from '@/pages/requests/detailPages/supplierDetailPages/SupplierDocForm.vue'
import SuppliersKYCForm from '@/pages/requests/detailPages/supplierDetailPages/SupplierKYCForm.vue'
import SupplierEditPage from '@/pages/requests/editPages/SupplierEditTemplate.vue'
import SendDocumentsFromApplicationForm from '@/pages/LMSGiframe/SendDocumentsFromApplicationForm.vue'
import AddNote from '@/pages/requests/detailPages/supplierDetailPages/AddNote.vue'
import EditNote from '@/pages/requests/detailPages/supplierDetailPages/EditNote.vue'
import KYCScores from '@/pages/requests/KYCScores.vue'
import KYCExceptions from '@/pages/requests/KYCExceptions.vue'
import AddKYCExceptions from '@/pages/requests/AddKYCExceptions.vue'
import EditKYCExceptions from '@/pages/requests/EditKYCExceptions.vue'

export default [
  {
    path: '/suppliers/documentsToValidateDetails',
    alias: [],
    component: DocumentToValidateDetailPage
  },
  {
    path: '/invoices/create',
    alias: [],
    component: InvoiceCreateForm
  },
  {
    path: '/projects/create',
    alias: [],
    component: ProjectCreateForm
  },
  {
    path: '/suppliers/create',
    alias: [],
    component: SupplierCreateForm
  },
  {
    path: '/suppliers/list',
    alias: [],
    component: SuppliersList
  },
  {
    path: '/suppliers/details',
    alias: [],
    component: SuppliersDetailPage
  },
  {
    path: '/suppliers/docform',
    alias: [],
    component: SuppliersDocForm
  },
  {
    path: '/suppliers/kycform',
    alias: [],
    component: SuppliersKYCForm
  },
  {
    path: '/suppliers/edit',
    alias: [],
    component: SupplierEditPage
  },
  {
    path: '/kycform/',
    component: SuppliersKYCForm
  },
  {
    path: '/sendDocumentsFromApplication/',
    component: SendDocumentsFromApplicationForm
  },
  {
    path: '/paymentFromApplication/',
    component: PaymentFromApplicationForm
  },
  {
    path: '/addnote/',
    component: AddNote
  },
  {
    path: '/editnote/:id',
    component: EditNote
  },
  {
    path: '/kycscores/',
    component: KYCScores
  },
  {
    path: '/kycexceptions/',
    component: KYCExceptions
  },
  {
    path: '/addkycexceptions/',
    component: AddKYCExceptions
  },
  {
    path: '/editkycexceptions/:id',
    component: EditKYCExceptions
  }
]
